<template>
  <div class="technologies" id="technologies">
    <div v-if="showServices" class="container">
      <h1 class="section-title">{{state.translation.technologies.title}}</h1>
      <div class="border-cust"></div>
      <div class="row m-0 pt-5 d-flex align-items-center justify-content-center text-center">
        <div class="col-4 col-lg-2 mt-3" v-for="(tech, index) in techs" :key="`techs-${index}`">
          <picture>
            <source :srcset="tech.replace('.png', '.webp')" type="image/webp">
            <source :srcset="tech" type="image/png">
            <img :src="tech" alt="">
          </picture>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import $ from 'jquery'

export default {
  name: 'Technologies',
  data() {
    return {
      techs: ['/nodejs.png', 'php.png', 'javascript.png', 'rest.png', 'wp.png', '/ios.png', '/android.png', 'html.png', 'css.png', 'vue.png', 'react.png', 'angular.png', 'mysql.png', 'mongo-db.png', 'laravel.png', 'laravel-blade.png', 'symphony.png', 'redis.png', 'bootstrap.png', 'sass.png', 'less.png', 'socketio.png', 'jade.png', 'handlebars.png', 'linux.png', 'docker.png', 'nativescript.png', 'jquery.png', 'photoshop.png', 'java.png', 'net-dot.png', 'paypal.png', 'braintree.png', 'stripe.png', 'aws.png', 'g2a.png'],
      state: this.$root.$data.state,
      showServices: false
    }
  },
  mounted() {
    var scroll = null;
    let self = this;

    $(window).scroll(function (event) {
        scroll = $(window).scrollTop();
        self.checkIfServInView(scroll);
    });
  },
  methods: {
    checkIfServInView(scroll) {
      let fromTop = $('#technologies').offset().top;
      let wh = $(window).height();
      console.log(scroll)
      console.log(fromTop)
      console.log(wh)
      if (scroll+wh>=fromTop) {
        this.showServices = true;
      }
    },
  }
}
</script>
